@if(liveCourses.length > 0){
  <section class="uc-home-courses" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container py-5">
      <h2 class="home-titles uc-home-section__title uc-display-sm" [class]="isRtl ? 'text-end' : 'text-start'" translate="home.liveCourses"></h2>
      <ul *ngIf="liveCourses?.length" class="d-flex align-items-center mt-4 mb-4">
        <li *ngIf="checkLength(courseType.LiveSessions)" (click)="type = courseType.LiveSessions;" [ngClass]="{'active': type === courseType.LiveSessions}" translate="home.liveCoursesTabs.remote"></li>
        <li *ngIf="checkLength(courseType.OnSite)" (click)="type = courseType.OnSite;" [ngClass]="{'active': type === courseType.OnSite}" translate="home.liveCoursesTabs.onSite"></li>
        <li *ngIf="checkLength(courseType.Compact)" (click)="type = courseType.Compact;" [ngClass]="{'active': type === courseType.Compact}" translate="home.liveCoursesTabs.hybrid"></li>
      </ul>
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 gy-4">
        <ng-container *ngIf="liveCourses?.length; else courseLoader">
          <div class="col" *ngFor="let course of getCoursesList(type)">
            <app-course-item [course]="course" context="home-live"></app-course-item>
          </div>
        </ng-container>
      </div>
      <div *ngIf="liveCourses?.length" class="text-center mt-4">
        <a class="btn btn-see-more uc-see-more border rounded-pill px-3 py-2" routerLink="/course" translate="home.seeMore"></a>
      </div>
    </div>
  </section>
}

<ng-template #courseLoader>
  <div class="col" *ngFor="let course of [1,2,3,4]">
    <div class="course-loader">
      <div class="d-flex align-items-center justify-content-between">
        <span class="d-block rounded-pill"></span>
        <span class="d-block rounded-pill"></span>
      </div>
      <div></div>
      <div class="d-flex align-items-center justify-content-between">
        <span class="d-block rounded-pill"></span>
        <span class="d-block rounded-pill"></span>
      </div>
    </div>
  </div>
</ng-template>